import { FileText, Plus, Layers } from "lucide-react";
import { useEditorStore, type LeftTab } from "../store";
import { PagesTab } from "./PagesTab";
import { AddTab } from "./AddTab";
import { LayersTab } from "./LayersTab";

const TABS: { id: LeftTab; label: string; icon: typeof FileText }[] = [
  { id: "pages", label: "Pages", icon: FileText },
  { id: "add", label: "Add", icon: Plus },
  { id: "layers", label: "Layers", icon: Layers },
];

export function LeftSidebar() {
  const leftTab = useEditorStore((s) => s.leftTab);
  const setLeftTab = useEditorStore((s) => s.setLeftTab);
  const width = useEditorStore((s) => s.leftSidebarWidth);
  const isCollapsed = useEditorStore((s) => s.leftSidebarCollapsed);

  return (
    <aside
      className={`zirro-left ${isCollapsed ? "zirro-left--collapsed" : ""}`}
      style={{ width: isCollapsed ? 60 : `${width}px` }}
      aria-label="Editor sidebar"
    >
      <nav className="zirro-left__tabs" aria-label="Sidebar tabs">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = leftTab === tab.id && !isCollapsed;
          return (
            <button
              key={tab.id}
              type="button"
              className={`zirro-left__tab-btn ${isActive ? "zirro-left__tab-btn--active" : ""}`}
              aria-pressed={isActive}
              onClick={() => {
                if (leftTab === tab.id && !isCollapsed) {
                  useEditorStore.getState().toggleLeftSidebar();
                } else {
                  if (isCollapsed) {
                    useEditorStore.getState().toggleLeftSidebar();
                  }
                  setLeftTab(tab.id);
                }
              }}
              title={tab.label}
            >
              <Icon size={18} />
              {tab.label}
            </button>
          );
        })}
      </nav>

      {!isCollapsed ? (
        <div className="zirro-left__panel">
          {leftTab === "pages" ? <PagesTab /> : null}
          {leftTab === "add" ? <AddTab /> : null}
          {leftTab === "layers" ? <LayersTab /> : null}
        </div>
      ) : null}
    </aside>
  );
}
